import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import route from '../../../vendor/tightenco/ziggy/src/js/route';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import momentPlugin from '@fullcalendar/moment';
import listPlugin from '@fullcalendar/list';
import {formatDate} from '@fullcalendar/core';
import moment from 'moment';
import $ from 'jquery';
import interactionPlugin from '@fullcalendar/interaction';
import 'bootstrap';
import {MDCCheckbox} from '@material/checkbox';
import {MDCDialog} from '@material/dialog';
import {Button} from '@rmwc/button';
import {IconButton} from '@rmwc/icon-button';
import ScheduleDetail from './ScheduleDetail';


axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

$('.js-show-new-class').click(function (event) {
    event.preventDefault();

    document.querySelector('.js-add-new-class-drawer').Pushbar.open();
});

$('.js-add-workout-button').click(function () {
    document.querySelector('.js-add-workout-to-class-drawer').Pushbar.open();
});

export default class Calendar extends Component {
    constructor(props) {
        super(props);
        this.calendarRef = React.createRef();
        // Setup local storage correctly
        if (!localStorage.getItem('activeView')) {
            localStorage.setItem('activeView', 'week');
        }

        if (!localStorage.getItem('activeFilters')) {
            localStorage.setItem('activeFilters', JSON.stringify([]));
        }

        // Setup the current view
        document.querySelectorAll('.js-view-toggles').forEach(element => (element.checked = false));

        switch (localStorage.getItem('activeView')) {
            case 'day':
                document.querySelector('.js-active-filter').innerHTML = 'Day';
                break;
            case 'week':
                document.querySelector('.js-active-filter').innerHTML = 'Week';
                break;
            case 'month':
                document.querySelector('.js-active-filter').innerHTML = 'Month';
                break;
            case 'list':
                document.querySelector('.js-active-filter').innerHTML = 'List';
                break;
        }

        const selectedRadio = document.querySelector(
            '.js-calendar-' + localStorage.getItem('activeView') + '-view-radio'
        );
        if (selectedRadio !== null) {
            selectedRadio.checked = true;
        }

        const that = this;

        for (let form of document.forms) {
            if (
                form.classList.contains('js-add-new-class-form') ||
                form.classList.contains('js-edit-class-form')
            ) {
                continue;
            }
            form.addEventListener('submit', function (event) {
                event.preventDefault();

                const loader = form.closest('aside').getElementsByClassName('js-loader')[0];
                if (loader) {
                    loader.style.display = 'block';
                }

                const formData = new FormData(event.target);

                const dataToSend = {};

                for (let data of formData) {
                    dataToSend[data[0]] = data[1];
                }

                axios
                    .post(event.target.action, dataToSend)
                    .then(function (result) {
                        if (loader) {
                            loader.style.display = 'none';
                        }
                        event.target.closest('.pushbar').Pushbar.closeAll();
                        that.calendarRef.current.getApi().refetchEvents();

                        setTimeout(function () {
                            // This will ensure that after the form was succesfully submitted the form is both
                            // - Scrolled to the top again
                            // - Reset to its initial state
                            form.closest('main').scrollTop = 0;
                            form.reset();
                        }, 300); // Same timeout as is used for pushbar animation
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
        }

        // Parse localStorage once when the component loads
        const activeFilters = JSON.parse(localStorage.getItem('activeFilters')) || [];

        document.querySelectorAll('.js-filter-item').forEach(element => {
            element.addEventListener('click', event => {
                const checkbox = element.querySelector('.mdc-checkbox__native-control');

                if (!checkbox.dataset.checked) {
                    activeFilters.push(element.dataset.id);
                    checkbox.dataset.checked = 'true';
                } else {
                    delete checkbox.dataset.checked;
                    const index = activeFilters.indexOf(element.dataset.id);
                    if (index > -1) {
                        activeFilters.splice(index, 1);
                    }
                }

                // Update localStorage here
                localStorage.setItem('activeFilters', JSON.stringify(activeFilters));
            });
        });


        $('.js-apply-filter-button').click(() => {
            this.calendarRef.current.getApi().rerenderEvents();
        });

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this.calendarRef.current.getApi().refetchEvents();
            }
        });

        $('.js-calendar-day-view').click(() => {
            this.calendarRef.current.getApi().changeView('timeGridDay');
            document
                .querySelectorAll('.js-view-toggles')
                .forEach(element => (element.checked = false));
            document.querySelector('.js-active-filter').innerHTML = 'Day';
            localStorage.setItem('activeView', 'day');
        });

        $('.js-calendar-week-view').click(() => {
            this.calendarRef.current.getApi().changeView('timeGridWeek');
            document
                .querySelectorAll('.js-view-toggles')
                .forEach(element => (element.checked = false));
            document.querySelector('.js-active-filter').innerHTML = 'Week';
            localStorage.setItem('activeView', 'week');
        });

        $('.js-calendar-month-view').click(() => {
            this.calendarRef.current.getApi().changeView('dayGridMonth');
            document
                .querySelectorAll('.js-view-toggles')
                .forEach(element => (element.checked = false));
            document.querySelector('.js-active-filter').innerHTML = 'Month';
            localStorage.setItem('activeView', 'month');
        });

        $('.js-calendar-list-view').click(() => {
            this.calendarRef.current.getApi().changeView('listDay');
            document
                .querySelectorAll('.js-view-toggles')
                .forEach(element => (element.checked = false));
            document.querySelector('.js-active-filter').innerHTML = 'List';
            localStorage.setItem('activeView', 'list');
        });

        $('.js-calendar-day-view-radio').click(() => {
            this.calendarRef.current.getApi().changeView('timeGridDay');
            document
                .querySelectorAll('.js-view-toggles')
                .forEach(element => (element.checked = false));
            document.querySelector('.js-calendar-day-view-radio').checked = true;
            localStorage.setItem('activeView', 'day');
        });

        $('.js-calendar-week-view-radio').click(() => {
            this.calendarRef.current.getApi().changeView('timeGridWeek');
            document
                .querySelectorAll('.js-view-toggles')
                .forEach(element => (element.checked = false));
            document.querySelector('.js-calendar-week-view-radio').checked = true;
            localStorage.setItem('activeView', 'week');
        });

        $('.js-calendar-month-view-radio').click(() => {
            this.calendarRef.current.getApi().changeView('dayGridMonth');
            document
                .querySelectorAll('.js-view-toggles')
                .forEach(element => (element.checked = false));
            document.querySelector('.js-calendar-month-view-radio').checked = true;
            localStorage.setItem('activeView', 'month');
        });

        $('.js-calendar-list-view-radio').click(() => {
            this.calendarRef.current.getApi().changeView('listDay');
            document
                .querySelectorAll('.js-view-toggles')
                .forEach(element => (element.checked = false));
            document.querySelector('.js-calendar-list-view-radio').checked = true;
            localStorage.setItem('activeView', 'list');
        });

        $('.js-add-class-fab').click(() => {
            document.querySelector('.js-add-class-drawer input[name="schedule_date"]').value = '';
            document.querySelector('.js-add-class-drawer input[name="start_time"]').value = '';
            document.querySelector('.js-add-class-drawer input[name="end_time"]').value = '';

            showAddNewClassDrawer();
        });
    }

    componentDidMount() {
        // Parse localStorage once when the component loads
        const activeFilters = JSON.parse(localStorage.getItem('activeFilters')) || [];

        // Initialize the dialog
        const dialog = new MDCDialog(document.querySelector('.js-filter-dialog'));

        // Listen for dialog opening
        dialog.listen('MDCDialog:opened', () => {
            // Loop through activeFilters to initialize checkboxes
            activeFilters.forEach(classTypeId => {
                const checkbox = new MDCCheckbox(
                    document.querySelector('#checkbox-' + classTypeId).parentElement
                );
                checkbox.checked = true;
                document.querySelector('#checkbox-' + classTypeId).dataset.checked = 'true';
            });
        });
    }

    retrieveEvents = (fetchInfo, successCallback, failureCallback) => {
        $('.js-loader-schedule').show();
        axios
            .get(
                route('schedule_json', {
                    start: moment(fetchInfo.start).add(moment(fetchInfo.start).utcOffset(), 'minute').toISOString(),
                    end: moment(fetchInfo.end).add(moment(fetchInfo.end).utcOffset(), 'minute').toISOString()
                })
            )
            .then(response => {
                if (
                    response.data === undefined ||
                    (response.data && response.data.events && response.data.events.length === 0)
                ) {
                    $('#schedule_empty_modal').modal('show');
                } else {
                    $('#schedule_empty_modal').hide('hide');
                }
                $('.js-loader-schedule').hide();
                successCallback(response.data.events);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    window.location = route('login');
                }
                failureCallback(error);
            });
    };

    eventRender = info => {
        let originalEvent = info.event;

        const filters = JSON.parse(localStorage.getItem('activeFilters'));

        if (filters.length > 0 && !filters.includes(originalEvent.extendedProps.classTypeId)) {
            return false;
        }

        const eventStart = moment(originalEvent.start);
        const eventEnd = moment(originalEvent.end);
        const eventTitle = originalEvent.title;
        const event = originalEvent.extendedProps;

        info.el.className += ` js_class_add_wod_drawer ${
            event.isOnWaitingList ? 'waiting-list' : ''
        } ${event.subscribed ? 'signed' : ''} ${
            event.isAdmin && event.workoutId ? 'has_workout' : ''
        }`;

        var toRender = ``;

        if (info.view.type === 'listDay') {
            toRender = `<td>`;
        }

        toRender += `<div class="fc-content">
                <div class="fc-time"><span>${eventStart.format(
            'HH:mm'
        )} <span class="time_divider">-</span> ${eventEnd.format('HH:mm')}</span></div>
                <div class="fc-title">${eventTitle}</div>
                <span class="total-signups">${event.totalRegistrations}/${
            event.totalPossibleRegistrations
        }</span>`;

        if (event.isAdmin) {
            toRender += `<div class="add_workout  text-center">
                <div class="mdl-tooltip mdl-tooltip--left" for="add_tooltip">Add workout</div>`;

            if (event.workoutId) {
                toRender += `<span class="workout_checked">
                                <i class="material-icons text-success workout-check" tabindex="0">check_circle</i></span>`;
            } else {
                toRender += `<button class="js_add_wod_drawer mdl-button mdl-js-button mdl-button--raised mdl-button--icon">
                                <i class="material-icons add-workout-to-class" id="add_tooltip" tabindex="0">add</i></button>`;
            }

            toRender += `</div>`;
        } else if (event.subscribed) {
            toRender += `<div class="text-center event_status">
                <i class="material-icons text-white workout_check">check</i>
                </div>`;
        } else if (event.isOnWaitingList) {
            toRender += `<div class="text-center event_status">
                <i class="material-icons workout_check">alarm</i>
                </div>`;
        }

        toRender += `
                </div>`;

        if (info.view.type === 'listDay') {
            toRender += `</td>`;
        }

        info.el.innerHTML = toRender;

        const urlParams = new URLSearchParams(window.location.hash.substr(1));
        const eventIdentifier = urlParams.get('eventIdentifier');
        if (eventIdentifier && event.uniqueId === eventIdentifier) {
            urlParams.delete('eventIdentifier');
            window.location.hash = urlParams.toString();
            // This is not great, but this forces the componentDidMount to be called in which the data call happens.
            // Eventually this should all be react anyway.
            ReactDOM.unmountComponentAtNode(document.getElementById('js-schedule-detail-drawer'));
            ReactDOM.render(
                <ScheduleDetail
                    event={originalEvent}
                    el={info.el}
                    refresh={() => this.calendarRef.current.getApi().refetchEvents()}
                />,
                document.getElementById('js-schedule-detail-drawer')
            );
            document.querySelector('.js-detail-drawer-react').Pushbar.open();
        }

        return info.el;
    };

    datesRender = info => {
        document.querySelector('.fc-header-date').innerHTML = info.view.title;

        $('#calendar.enhanced .fc-day-header').click((event) => {
            document.querySelector('.js-delete-event-day').MDCDialog.open();
            document.querySelector('.js-delete-event-day .js-delete-event-day-ok-button').dataset.dayDate =
                $(event.currentTarget).closest('.fc-day-header').data('date')
        });

        $('.js-delete-event-day-ok-button').click(() => {
            window.location = route('schedule_delete_whole_day',
                {
                    'date': $('.js-delete-event-day-ok-button').data('dayDate'),
                })
        });
    };

    dateClick = info => {
        const date = moment(info.date);
        if (!document.querySelector('.js-add-class-drawer')) {
            return;
        }

        document.querySelector(
            '.js-add-class-drawer input[name="schedule_date"]'
        ).value = date.format('YYYY-MM-DD');
        document.querySelector('.js-add-class-drawer input[name="start_time"]').value = date.format(
            'HH:mm:ss'
        );
        document.querySelector('.js-add-class-drawer input[name="end_time"]').value = date
            .add('1', 'hour')
            .format('HH:mm:ss');

        showAddNewClassDrawer();
    };

    eventClick = info => {
        const jsEvent = info.jsEvent;
        let event = info.event;
        const eventTitle = event.title;
        const eventStart = moment(event.start);
        const eventEnd = moment(event.end);
        event = event.extendedProps;

        if (jsEvent.target.classList.contains('add-workout-to-class')) {
            document.querySelector('.js-add-workout-form input[name="schedule_id"]').value =
                event.eventId;
            document.querySelector('.js-add-new-workout-form input[name="schedule_id"]').value =
                event.eventId;
            document.querySelector(
                '.js-add-workout-form input[name="schedule_date"]'
            ).value = eventStart.format('YYYY-MM-DD');
            document.querySelector(
                '.js-add-new-workout-form input[name="schedule_date"]'
            ).value = eventStart.format('YYYY-MM-DD');

            document.querySelector('.js-add-workout-to-class-drawer').Pushbar.open();
            return;
        }

        // This is not great, but this forces the componentDidMount to be called in which the data call happens.
        // Eventually this should all be react anyway.
        ReactDOM.unmountComponentAtNode(document.getElementById('js-schedule-detail-drawer'));
        ReactDOM.render(
            <ScheduleDetail
                event={info.event}
                el={info.el}
                rerender={() => this.calendarRef.current.getApi().rerenderEvents()}
                refresh={() => this.calendarRef.current.getApi().refetchEvents()}
            />,
            document.getElementById('js-schedule-detail-drawer')
        );
        document.querySelector('.js-detail-drawer-react').Pushbar.open();
    };

    selectRange = selectionInfo => {
        console.log(selectionInfo);
    };

    unselectRange = (jsEvent, view) => {
        console.log(jsEvent, view);
    };

    render() {
        return (
            <div>
                <div className="fc-toolbar fc-header-toolbar d-flex align-items-center">
                    <div className="fc-left">
                        <span className="fc-header-date"></span>
                    </div>
                    <div className="fc-center"></div>
                    <div className="fc-right ml-auto d-flex align-items-center mr-2">
                        <Button
                            onClick={() => this.calendarRef.current.getApi().today()}
                            label={'Today'}
                        />
                        <IconButton
                            onClick={() => this.calendarRef.current.getApi().prev()}
                            icon={'keyboard_arrow_left'}
                        />
                        <IconButton
                            onClick={() => this.calendarRef.current.getApi().next()}
                            icon={'keyboard_arrow_right'}
                        />
                    </div>
                </div>
                <FullCalendar
                    defaultView={
                        localStorage.getItem('activeView') === 'day'
                            ? 'timeGridDay'
                            : localStorage.getItem('activeView') === 'week'
                                ? 'timeGridWeek'
                                : localStorage.getItem('activeView') === 'month'
                                    ? 'dayGridMonth'
                                    : 'listDay'
                    }
                    ref={this.calendarRef}
                    height={'auto'}
                    lazyFetching={false}
                    plugins={[
                        timeGridPlugin,
                        momentPlugin,
                        interactionPlugin,
                        dayGridPlugin,
                        listPlugin
                    ]}
                    header={false}
                    editable={false}
                    handleWindowResize={false}
                    events={this.retrieveEvents}
                    eventRender={this.eventRender}
                    eventPositioned={info => {
                        // We have to make sure that two classes are there:
                        // .fc-short will be added by fullcalendar, and .fc-medium we'll add.
                        // I'll make sure to add .fc-short too though just to prevent issues that it will be removed later.
                        const height = info.el.getBoundingClientRect()['height'];

                        if (height <= 60 && height > 30) {
                            info.el.classList.add('fc-medium');
                        } else if (height <= 30) {
                            info.el.classList.add('fc-short');
                        }
                    }}
                    nowIndicator={true}
                    slotEventOverlap={false}
                    eventOverlap={false}
                    datesRender={this.datesRender}
                    eventClick={this.eventClick}
                    dateClick={this.dateClick}
                    minTime={'07:00:00'}
                    maxTime={'22:30:00'}
                    firstDay={1}
                    slotLabelInterval={'01:00'}
                    slotLabelFormat={'H:mm'}
                    // selectable={true}
                    // select={this.selectRange}
                    // unselect={this.unselectRange}
                    views={{
                        week: {
                            columnHeaderHtml: date => {
                                const weekDay = formatDate(date, {
                                    weekday: 'short'
                                });

                                const shortDay = formatDate(date, {
                                    day: 'numeric'
                                });

                                return `${weekDay} ${shortDay}`;
                            }
                        },
                        day: {
                            titleFormat: {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                            }
                        }
                    }}
                    displayEventTime={true}
                    displayEventEnd={true}
                    allDaySlot={false}
                    longPressDelay={'0'}
                />
            </div>
        );
    }
}

if (document.getElementById('calendar')) {
    ReactDOM.render(<Calendar/>, document.getElementById('calendar'));
}

function showAddNewClassDrawer() {
    document.querySelector('.js-add-class-drawer').Pushbar.open();

    document.querySelector('.js-add-new-class-drawer form').onsubmit = function (e) {
        e.preventDefault();
        const form = e.target;
        const title = form.querySelector('input[name=title]').value;
        const description = form.querySelector('textarea[name=description]').value;
        const max_amount_of_people = form.querySelector('input[name=max_amount_of_people]').value;
        const credits_cost = form.querySelector('input[name=credits_cost]').value;
        const show_on_dashboard = form.querySelector('input[name=show_on_dashboard]').checked;
        const always_show_workout_details = form.querySelector(
            'input[name=always_show_workout_details]'
        ).checked;

        const loader = form.closest('aside').getElementsByClassName('js-loader')[0];

        if (loader) {
            loader.style.display = 'block';
        }

        axios
            .post(route('class_type_create_json'), {
                title,
                description,
                max_amount_of_people,
                credits_cost,
                show_on_dashboard,
                always_show_workout_details
            })
            .then(response => {
                if (loader) {
                    loader.style.display = 'none';
                }
                const classType = response.data.class_type;
                document.querySelector(
                    '.js-add-class-drawer select'
                ).innerHTML += `<option selected value="${classType.id}">${classType.title}</option>`;
                document.querySelector('.js-add-new-class-drawer').Pushbar.close();
            })
            .catch(error => {
                console.log(error);
            });
    };
}
